import activities from '@/api/activities';
import meetings from '@/api/meetings';

export default {
  activities,
  meetings,
};
